import { useCreateOperator } from '../../../../../contexts/CreateOperatorContext';
import { SettingRow } from '../../../../Manage/Operator/Settings/SettingRow';
import { Input } from '../../../../../components/Input';
import { Divider } from '../../../../../components/Divider';
import { SettingTag } from '../../SettingTag';
import { ChangeEvent } from 'react';
import { Switch } from '../../../../../components/Switch';
import React from 'react';

export const MediaFirstSettings = () => {
  const { operator, updateOperator } = useCreateOperator();
  const classes = useStyles();

  if (operator.mediaFirstSettings === undefined) return null;

  const tag = <SettingTag name="MediaFirst" color="teal" size="sm" />;

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    updateOperator(
      'mediaFirstSettings',
      Object.assign(operator.mediaFirstSettings!, {
        [event.target.name]: event.target.value,
      })
    );
  };

  const defaultInputProps: any = {
    variant: 'contained',
    onChange: handleChange,
  };

  const settings: SettingRowConfig[] = [
    {
      order: 1,
      component: (
        <Input
          name="subTenantId"
          className={classes.input}
          value={operator.mediaFirstSettings?.subTenantId ?? ''}
          {...defaultInputProps}
        />
      ),
      icon: tag,
      title: 'Sub-Tenant ID',
      level: 'sub',
      show: true,
    },
    {
      order: 2,
      component: (
        <Switch
          onChange={(event) =>
            updateOperator(
              'mediaFirstSettings',
              Object.assign(operator.mediaFirstSettings!, {
                usesTgAuth: event.target.checked,
              })
            )
          }
          checked={operator.mediaFirstSettings?.usesTgAuth ?? false}
        />
      ),
      icon: tag,
      title: 'Uses Tangerine OAuth',
      level: 'sub',
      show: true,
    },
    {
      order: 3,
      component: (
        <Input
          name="recorderId"
          value={operator.mediaFirstSettings?.recorderId ?? ''}
          {...defaultInputProps}
        />
      ),
      icon: tag,
      title: 'Recorder ID',
      level: 'sub',
      show: true,
    },
    {
      order: 4,
      component: (
        <Input
          name="defaultDeviceStreamCount"
          className={classes.input}
          type="number"
          min={0}
          value={operator.mediaFirstSettings?.defaultDeviceStreamCount ?? ''}
          {...defaultInputProps}
        />
      ),
      icon: tag,
      title: 'Device Stream Count',
      description: 'The default number of reach device streams on accounts',
      level: 'sub',
      show: true,
    },
  ];

  const renderDivider = (index: number) => {
    if (index + 1 === settings.filter((setting) => setting.show).length) return;
    return <Divider />;
  };

  return (
    <>
      {settings
        .filter((setting) => setting.show)
        .map((setting, index) => (
          <React.Fragment key={`operator-mediaFirst-setting-${index + 1}`}>
            <SettingRow
              title={setting.title}
              description={setting.description}
              icon={setting.icon}
              level={setting.level}
            >
              {setting.component}
            </SettingRow>
            {renderDivider(index)}
          </React.Fragment>
        ))}
    </>
  );
};

const useStyles = () => ({
  input: 'w-[80px]',
});
